"use strict";

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var Error_exports = {};
__export(Error_exports, {
  ClerkAPIResponseError: function ClerkAPIResponseError() {
    return _ClerkAPIResponseError;
  },
  MagicLinkError: function MagicLinkError() {
    return _MagicLinkError;
  },
  MagicLinkErrorCode: function MagicLinkErrorCode() {
    return _MagicLinkErrorCode;
  },
  isClerkAPIResponseError: function isClerkAPIResponseError() {
    return _isClerkAPIResponseError;
  },
  isKnownError: function isKnownError() {
    return _isKnownError;
  },
  isMagicLinkError: function isMagicLinkError() {
    return _isMagicLinkError;
  },
  isMetamaskError: function isMetamaskError() {
    return _isMetamaskError;
  },
  parseError: function parseError() {
    return _parseError;
  },
  parseErrors: function parseErrors() {
    return _parseErrors;
  }
});
module.exports = __toCommonJS(Error_exports);
function _isKnownError(error) {
  return _isClerkAPIResponseError(error) || _isMetamaskError(error);
}
function _isClerkAPIResponseError(err) {
  return "clerkError" in err;
}
function _isMetamaskError(err) {
  return "code" in err && [4001, 32602, 32603].includes(err.code) && "message" in err;
}
function _parseErrors() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return data.length > 0 ? data.map(_parseError) : [];
}
function _parseError(error) {
  var _error$meta, _error$meta2, _error$meta3, _error$meta4;
  return {
    code: error.code,
    message: error.message,
    longMessage: error.long_message,
    meta: {
      paramName: error === null || error === void 0 ? void 0 : (_error$meta = error.meta) === null || _error$meta === void 0 ? void 0 : _error$meta.param_name,
      sessionId: error === null || error === void 0 ? void 0 : (_error$meta2 = error.meta) === null || _error$meta2 === void 0 ? void 0 : _error$meta2.session_id,
      emailAddresses: error === null || error === void 0 ? void 0 : (_error$meta3 = error.meta) === null || _error$meta3 === void 0 ? void 0 : _error$meta3.email_addresses,
      zxcvbn: error === null || error === void 0 ? void 0 : (_error$meta4 = error.meta) === null || _error$meta4 === void 0 ? void 0 : _error$meta4.zxcvbn
    }
  };
}
var _ClerkAPIResponseError = /*#__PURE__*/function (_Error) {
  _inherits(_ClerkAPIResponseError, _Error);
  var _super = _createSuper(_ClerkAPIResponseError);
  function _ClerkAPIResponseError(message, _ref) {
    var _this;
    var data = _ref.data,
      status = _ref.status;
    _classCallCheck(this, _ClerkAPIResponseError);
    _this = _super.call(this, message);
    _this.toString = function () {
      return "[".concat(_this.name, "]\nMessage:").concat(_this.message, "\nStatus:").concat(_this.status, "\nSerialized errors: ").concat(_this.errors.map(function (e) {
        return JSON.stringify(e);
      }));
    };
    Object.setPrototypeOf(_assertThisInitialized(_this), _ClerkAPIResponseError.prototype);
    _this.status = status;
    _this.message = message;
    _this.clerkError = true;
    _this.errors = _parseErrors(data);
    return _this;
  }
  return _createClass(_ClerkAPIResponseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var _MagicLinkError = /*#__PURE__*/function (_Error2) {
  _inherits(_MagicLinkError, _Error2);
  var _super2 = _createSuper(_MagicLinkError);
  function _MagicLinkError(code) {
    var _this2;
    _classCallCheck(this, _MagicLinkError);
    _this2 = _super2.call(this, code);
    _this2.code = code;
    Object.setPrototypeOf(_assertThisInitialized(_this2), _MagicLinkError.prototype);
    return _this2;
  }
  return _createClass(_MagicLinkError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function _isMagicLinkError(err) {
  return err instanceof _MagicLinkError;
}
var _MagicLinkErrorCode = {
  Expired: "expired",
  Failed: "failed"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkAPIResponseError: _ClerkAPIResponseError,
  MagicLinkError: _MagicLinkError,
  MagicLinkErrorCode: _MagicLinkErrorCode,
  isClerkAPIResponseError: _isClerkAPIResponseError,
  isKnownError: _isKnownError,
  isMagicLinkError: _isMagicLinkError,
  isMetamaskError: _isMetamaskError,
  parseError: _parseError,
  parseErrors: _parseErrors
});